export default __webpack_public_path__ + "static/media/treasury-icon.3b6903c2.svg";